import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-23b9ef68"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "new-user-box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "创建用户", -1 /* HOISTED */))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "note" }, null, -1 /* HOISTED */))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "note" }, " 软件默认登录用户名密码为 (smanga/smanga) ,您可以在此界面创建一个新的用户,或者是跳过,使用默认用户登录. ", -1 /* HOISTED */))
const _hoisted_5 = { class: "btn-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _createVNode(_component_el_form, {
      model: $setup.form,
      inline: true
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, { label: "用户名:" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: $setup.form.userName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.form.userName) = $event)),
              style: {"width":"11rem"}
            }, null, 8 /* PROPS */, ["modelValue"])
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_el_form_item, { label: "密码:" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: $setup.form.passWord,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.form.passWord) = $event)),
              style: {"width":"11rem"}
            }, null, 8 /* PROPS */, ["modelValue"])
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["model"]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: $setup.setting
      }, {
        default: _withCtx(() => [
          _createTextVNode("新建用户")
        ]),
        _: 1 /* STABLE */
      })
    ])
  ]))
}